export enum RoleStatus {
  Inactive,
  Active,
}
